import { BrandId, BrandIdType } from '@nsw-paginas-deslogadas/constants'
import { default as Nav } from './nav.svg'
import { default as Alta } from './alta.svg'
import { default as Alvaro } from './alvaro.svg'
import { default as Atalaia } from './atalaia.svg'
import { default as Bronstein } from './bronstein.svg'
import { default as Cedilab } from './cedilab.svg'
import { default as Cerpe } from './cerpe.svg'
import { default as Cytolab } from './cytolab.svg'
import { default as Delboni } from './delboni.svg'
import { default as Deliberato } from './deliberato.svg'
import { default as Exame } from './exame.svg'
import { default as Frischmann } from './frischmann.svg'
import { default as GilsonCidrim } from './gilsonCidrim.svg'
import { default as Image } from './image.svg'
import { default as Itulab } from './itulab.svg'
import { default as LaminaRj } from './laminaRj.svg'
import { default as LaminaSc } from './laminaSc.svg'
import { default as Lavoisier } from './lavoisier.svg'
import { default as Leme } from './leme.svg'
import { default as OswaldoCruz } from './oswaldoCruz.svg'
import { default as Previlab } from './previlab.svg'
import { default as SalomaoZoppi } from './salomaoZoppi.svg'
import { default as SergioFranco } from './sergioFranco.svg'
import { default as ValeClin } from './valeClin.svg'
import { default as SaoCamilo } from './saoCamilo.svg'
import { default as MultiImagem } from './multiImagem.svg'
import { default as CDPI } from './cdpi.svg'
import { default as CerpeBoris } from './cerpe-boris.svg'
import { default as ImageLeme } from './image-leme.svg'
import { default as SergioFrancoCDPI } from './sergiofranco-cdpi.svg'

type LogotypesType = {
    [key in BrandIdType]: {
        src: string
        alt: string
    }
}

export const Logotypes: LogotypesType = {
    [BrandId.Nav]: {
        src: Nav,
        alt: 'Logotipo Nav',
    },
    [BrandId.Delboni]: {
        src: Delboni,
        alt: 'Logotipo Delboni',
    },
    [BrandId.Lavoisier]: {
        src: Lavoisier,
        alt: 'Logotipo Lavoisier',
    },
    [BrandId.Bronstein]: {
        src: Bronstein,
        alt: 'Logotipo Bronstein',
    },
    [BrandId.Lamina]: {
        src: LaminaRj,
        alt: 'Logotipo Lâmina',
    },
    [BrandId.FrischmannAisengart]: {
        src: Frischmann,
        alt: 'Logotipo Frischmann Aisengart',
    },
    [BrandId.Alvaro]: {
        src: Alvaro,
        alt: 'Logotipo Álvaro',
    },
    [BrandId.LaminaDiagnosticos]: {
        src: LaminaSc,
        alt: 'Logotipo Lâmina Diagnósticos',
    },
    [BrandId.Atalaia]: {
        src: Atalaia,
        alt: 'Logotipo Atalaia',
    },
    [BrandId.ImageMemorial]: {
        src: Image,
        alt: 'Logotipo Image Memorial',
    },
    [BrandId.Exame]: {
        src: Exame,
        alt: 'Logotipo Exame',
    },
    [BrandId.AltaSp]: {
        src: Alta,
        alt: 'Logotipo Alta SP',
    },
    [BrandId.AltaRj]: {
        src: Alta,
        alt: 'Logotipo Alta RJ',
    },
    [BrandId.SergioFranco]: {
        src: SergioFranco,
        alt: 'Logotipo Sérgio Franco',
    },
    [BrandId.Cytolab]: {
        src: Cytolab,
        alt: 'Logotipo Cytolab',
    },
    [BrandId.Previlab]: {
        src: Previlab,
        alt: 'Logotipo Previlab',
    },
    [BrandId.Cerpe]: {
        src: Cerpe,
        alt: 'Logotipo Cerpe',
    },
    [BrandId.GilsonCidrim]: {
        src: GilsonCidrim,
        alt: 'Logotipo Gilson Cidrim',
    },
    [BrandId.OswaldoCruz]: {
        src: OswaldoCruz,
        alt: 'Logotipo Oswaldo Cruz',
    },
    [BrandId.Leme]: {
        src: Leme,
        alt: 'Logotipo Leme',
    },
    [BrandId.SalomaoZoppi]: {
        src: SalomaoZoppi,
        alt: 'Logotipo Salomão Zoppi',
    },
    [BrandId.ValeClin]: {
        src: ValeClin,
        alt: 'Logotipo ValeClin',
    },
    [BrandId.CedicCedilab]: {
        src: Cedilab,
        alt: 'Logotipo Cedic Cedilab',
    },
    [BrandId.Deliberato]: {
        src: Deliberato,
        alt: 'Logotipo Deliberato',
    },
    [BrandId.Itulab]: {
        src: Itulab,
        alt: 'Logotipo Itulab',
    },
    [BrandId.SaoCamilo]: {
        src: SaoCamilo,
        alt: 'Logotipo São Camilo',
    },
    [BrandId.CDPI]: {
        src: CDPI,
        alt: 'Logotipo CDPI Niterói',
    },
    [BrandId.CDPIRIO]: {
        src: CDPI,
        alt: 'Logotipo CDPI',
    },
    [BrandId.MultiImagemRJ]: {
        src: MultiImagem,
        alt: 'Logotipo Multi Imagem',
    },
    [BrandId.MultiImagemPetropolis]: {
        src: MultiImagem,
        alt: 'Logotipo Multi Imagem Petropolis',
    },
    [BrandId.CerpeBoris]: {
        src: CerpeBoris,
        alt: 'Logotipos Cerpe e Boris',
    },
    [BrandId.ImageLeme]: {
        src: ImageLeme,
        alt: 'Logotipos Image e Leme',
    },
    [BrandId.SergioFrancoCDPI]: {
        src: SergioFrancoCDPI,
        alt: 'Logotipos Sergio Franco e CDPI',
    },
}

export default Logotypes
